export default __webpack_public_path__ + "static/media/E0.7a32d207.mp3";